// @ is an alias to /src
import MainPage from '@/components/Home/MainPage.vue'
import MainInfo from '@/components/Home/MainInfo.vue'

export default {
  name: 'HomeView',
  components: {
    MainPage, MainInfo
  },
  data () {
    return {
      response: {
        data: {
          commSubject: '',
          commUserNm: '',
          regDate: '',
          commCount: 0,
          fileOrgNm: '',
          filePath: '',
          fileNm: '',
          commContent: ''
        }
      },
      popList: [],
      modal: false,
      filePath: ''
    }
  },
  async created () {
    this.response = await this.$get('home/popup')
    if (this.response.data.length !== 0) {
      for (let i = 0; i < this.response.data.length; i++) {
        if (!this.$cookies.isKey('popup')) {
          this.modal = true
        }
        this.popList.push(this.response.data[i])
      }
    }
  },
  methods: {
    getFileDownloadPath (filePath, fileNm) {
      if (!filePath) {
        return ''
      }

      let normalizedPath = filePath
      if (!normalizedPath.startsWith('/')) {
        normalizedPath = `/${normalizedPath}`
      }

      if (!fileNm) {
        return normalizedPath
      }

      const escapedFileNm = fileNm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const normalizedPathWithoutQuery = normalizedPath.split('?')[0].split('#')[0]

      if (new RegExp(`/${escapedFileNm}$`).test(normalizedPathWithoutQuery)) {
        return normalizedPath
      }

      if (normalizedPath.endsWith('/')) {
        return `${normalizedPath}${fileNm}`
      }

      const hasExtension = /\.[a-zA-Z0-9]+$/.test(normalizedPathWithoutQuery)
      if (!hasExtension) {
        return `${normalizedPath}/${fileNm}`
      }

      return normalizedPath
    },
    buildBoardFileDownloadUrl (filePath, fileNm, fileOrgName) {
      const baseUrl = (this.$store.state.boardFilePath || '').replace(/\/+$/, '')
      if (!baseUrl) return ''

      const mergedPath = this.getFileDownloadPath(filePath, fileNm)
      if (!mergedPath) return ''

      // API 응답에 'file/...'이 들어오는 경우 baseUrl('/files/file')와 중복 방지
      const normalizedMergedPath = mergedPath.replace(/^\/+/, '').replace(/^file\//, '')
      const encodedFileName = encodeURIComponent(fileOrgName || fileNm || '')

      return `${baseUrl}/${normalizedMergedPath}?download=true&fileName=${encodedFileName}`
    },
    isCookie () {
      this.$cookies.remove('popup')
      this.$cookies.set('popup', 'popValue', '1d')
      this.modalClose()
    },
    modalClose () {
      this.modal = false
    }
  }
}
